import React, { useEffect, useState } from "react";
import { useSensorsMap } from "../../contexts/SensorsMapProvider.jsx";
import { typeDetails, getCardinalDirectionShort } from "../../utils/sensors.js";
import LoadingSpinner from "../LoadingSpinner.jsx";
import { RxCross2 } from "react-icons/rx";
import { FaThermometerHalf } from "react-icons/fa";
import { WiHumidity, WiBarometer, WiHot, WiStrongWind } from "react-icons/wi";
import { getSensorDataByCodeArray } from "../../services/sensorsService.js";
import Skeleton from "react-loading-skeleton";

export default function SensoriDetailsCard() {
	const { state, dispatch, ACTIONS } = useSensorsMap();
	const [loading, setLoading] = useState(true);
	const [sensorData, setSensorData] = useState(null);

	useEffect(() => {
		const fetchDatas = () =>
			getSensorDataByCodeArray([
				14205, 14201, 14202, 57423, 57422, 57424, 14206, 57425, 14163, 57432, 14204,
			]).then((res) => setSensorData(res.data.sensors));

		fetchDatas();
		const interval = setInterval(fetchDatas, 5 * 60 * 1000);
		return () => clearInterval(interval);
	}, []);
	if (!sensorData && !state.selectedSensor)
		return (
			<div className="flex flex-col items-center h-full">
				<div className="w-full h-full">
					<Skeleton height={"40%"} className="mb-5" />
					<Skeleton height={"40%"} />
				</div>
			</div>
		);

	if (!state.selectedSensor)
		return (
			<div className="w-full max-w-full box-border h-full">
				<div className="space-y-6">
					{/* Atri Capoluogo */}
					<div className="bg-purple-100 rounded-lg p-4 shadow-md">
						<table className="table-auto w-full text-left">
							<tbody>
								<tr>
									<td className="font-bold text-purple-800 text-md whitespace-nowrap">
										Atri
									</td>
									<td className="text-gray-700  whitespace-nowrap hidden 2xl:table-cell text-center">
										<WiHot className="inline-block text-purple-500 text-xl mr-2" />
										<strong>
											{sensorData.find((s) => s.code === 14206).value ||
												"N/A"}{" "}
											w/m&#178;
										</strong>
									</td>
									<td className="text-right text-gray-700  whitespace-nowrap">
										<strong>
											{sensorData.find((s) => s.code === 14202).value ||
												"N/A"}{" "}
											%
										</strong>
										<WiHumidity className="inline-block text-purple-500 text-2xl ml-2" />
									</td>
								</tr>
								<tr>
									<td className="text-gray-700  whitespace-nowrap">
										<FaThermometerHalf className="inline-block text-purple-500 text-xl mr-2" />
										<strong>
											{sensorData.find((s) => s.code === 14201).value ||
												"N/A"}{" "}
											°C
										</strong>
									</td>
									<td className="text-gray-700  whitespace-nowrap hidden 2xl:table-cell text-center">
										<WiStrongWind className="inline-block text-purple-500 text-xl mr-2" />
										<strong>
											{sensorData
												.find((s) => s.code === 14204)
												.value.split("_")[0] || "N/A"}{" "}
											km/h&#178;
										</strong>
									</td>
									<td className="text-right text-gray-700  whitespace-nowrap">
										<strong>
											{sensorData.find((s) => s.code === 14205).value ||
												"N/A"}{" "}
											hPa
										</strong>
										<WiBarometer className="inline-block text-purple-500 text-2xl ml-2" />
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					{/* Fontanelle di Atri */}
					<div className="bg-green-100 rounded-lg p-4 shadow-md">
						<table className="table-auto w-full text-left">
							<tbody>
								<tr>
									<td className="font-bold text-green-800 text-md whitespace-nowrap">
										Fontanelle
									</td>
									<td className="text-gray-700  whitespace-nowrap hidden 2xl:table-cell text-center">
										<WiHot className="inline-block text-green-500 text-2xl mr-2" />
										<strong>
											{sensorData.find((s) => s.code === 57425).value ||
												"N/A"}{" "}
											w/m&#178;
										</strong>
									</td>
									<td className="text-right text-gray-700  whitespace-nowrap">
										<strong>
											{sensorData.find((s) => s.code === 57424).value ||
												"N/A"}{" "}
											%
										</strong>
										<WiHumidity className="inline-block text-green-500 text-2xl ml-2" />
									</td>
								</tr>
								<tr>
									<td className="text-gray-700  whitespace-nowrap">
										<FaThermometerHalf className="inline-block text-green-500 text-xl mr-2" />
										<strong>
											{sensorData.find((s) => s.code === 57423).value ||
												"N/A"}{" "}
											°C
										</strong>
									</td>
									<td className="text-gray-700  whitespace-nowrap hidden 2xl:table-cell text-center">
										<WiStrongWind className="inline-block text-green-500 text-2xl mr-2" />
										<strong>
											{sensorData
												.find((s) => s.code === 57432)
												.value.split("_")[0] || "N/A"}{" "}
											km/h
										</strong>
									</td>
									<td className="text-right text-gray-700  whitespace-nowrap">
										<strong>
											{sensorData.find((s) => s.code === 57422).value ||
												"N/A"}{" "}
											hPa
										</strong>
										<WiBarometer className="inline-block text-green-500 text-2xl ml-2" />
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		);

	return (
		<div className="w-full max-w-full box-border h-full">
			{state.selectedSensor && (
				<div>
					<h3 className="text-xl mb-4 flex justify-between items-center overflow-hidden">
						{/* Nome del sensore (allineato a sinistra) */}
						<span className="flex items-start gap-2">
							<RxCross2
								className="self-start mt-1 cursor-pointer"
								onClick={() => dispatch({ type: ACTIONS.CLEAR_SELECTED_SENSOR })}
							/>
							<span className="font-semibold text-left truncate">
								{state.selectedSensor.name}
							</span>
						</span>

						{/* Valore del sensore (allineato a destra) */}
						<span className="text-purple-800 text-right truncate">
							{typeDetails[state.selectedSensor.type].useCardinal &&
							state.selectedSensor.value.includes("_")
								? (() => {
										const [speed, direction] =
											state.selectedSensor.value.split("_");
										return `${speed} ${
											typeDetails[state.selectedSensor.type].unit
										} ${getCardinalDirectionShort(parseInt(direction, 10))}`;
								  })()
								: `${state.selectedSensor.value} ${
										typeDetails[state.selectedSensor.type].unit
								  }`}
						</span>
					</h3>

					{/* Grafico (se presente il link) */}
					{state.selectedSensor.chart_link && (
						<div className="mt-4 flex justify-center">
							{loading && <LoadingSpinner />}
							<img
								src={state.selectedSensor.chart_link}
								alt={`Grafico storico per ${state.selectedSensor.name}`}
								className={`h-auto rounded-lg border ${
									loading ? "hidden" : "block"
								}`}
								onLoad={() => setLoading(false)}
								onError={() => setLoading(false)}
							/>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
